import { PropsWithChildren } from 'react';
import type { BoxProps } from '@rebass/grid';

import GridContainer from './styles';

type ContainerProps = Pick<BoxProps, 'className' | 'as' | 'p' | 'm'> & {
  display?: string;
  position?: string;
  alignItems?: string;
  justifyContent?: string;
  textAlign?: string;
}

const Container = (props: PropsWithChildren<ContainerProps>) => {
  const {
    children,
    className,
    as,
    p,
    m,
    display,
    position,
    alignItems,
    justifyContent,
    textAlign,
  } = props;
  return (
    <GridContainer
      className={className}
      as={as}
      p={p}
      m={m}
      position={position}
      display={display}
      alignItems={alignItems}
      justifyContent={justifyContent}
      textAlign={textAlign}
      {...props}
    >
      {children}
    </GridContainer>
  );
};

export default Container;
